import removeQueryParam from './removeQueryParam';

export default removeQueryParam;
